import styled from "styled-components";
import CustomButton from "../../../../helperComponents/CustomButton";
import { BsPerson } from "react-icons/bs";
import { GoLocation } from "react-icons/go";
import { GrConfigure } from "react-icons/gr";
import { BiTask } from "react-icons/bi";
import { FaRegMap } from "react-icons/fa";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export default function ButtonsForManagement() {
  return (
    <Container>
      <CustomButton icon={<BsPerson />} href={"/add-employee"}>
        Ajouter un employé
      </CustomButton>
      <CustomButton icon={<GoLocation />} href={"/add-site"}>
        Ajouter un site
      </CustomButton>
      <CustomButton icon={<GrConfigure />} href={"/add-role"}>
        Créer un rôle
      </CustomButton>
      <CustomButton icon={<FaRegMap />} href={"/add-zone"}>
        Ajouter une zone
      </CustomButton>
    </Container>
  );
}
